/**
 * DJ Black Taro Sound — Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  // ---- Generate Confetti ----
  var confettiContainer = document.getElementById('confetti-container');
  if (confettiContainer) {
    var colors = ['#FFD700', '#7C3AED', '#FF6B6B', '#00E5FF', '#FF4081', '#00E676'];
    for (var i = 0; i < 30; i++) {
      var piece = document.createElement('div');
      piece.className = 'bts-confetti-piece';
      var size = Math.random() * 8 + 4;
      piece.style.cssText =
        'left:' + Math.random() * 100 + '%;' +
        'width:' + size + 'px;' +
        'height:' + size + 'px;' +
        'background:' + colors[Math.floor(Math.random() * colors.length)] + ';' +
        'border-radius:' + (Math.random() > 0.5 ? '50%' : '2px') + ';' +
        'animation-duration:' + (Math.random() * 4 + 4) + 's;' +
        'animation-delay:' + (Math.random() * 5) + 's;' +
        'opacity:' + (Math.random() * 0.5 + 0.3) + ';';
      confettiContainer.appendChild(piece);
    }
  }

  // ---- Generate Particles ----
  var particlesContainer = document.getElementById('particles-container');
  var nlParticles = document.getElementById('newsletter-particles');
  [particlesContainer, nlParticles].forEach(function(container) {
    if (!container) return;
    var particleColors = ['#FFD700', '#7C3AED'];
    for (var i = 0; i < 25; i++) {
      var p = document.createElement('div');
      p.className = 'bts-particle';
      var ps = Math.random() * 3 + 1;
      var pc = particleColors[Math.random() > 0.4 ? 0 : 1];
      p.style.cssText =
        'left:' + Math.random() * 100 + '%;' +
        'width:' + ps + 'px;' +
        'height:' + ps + 'px;' +
        'background:' + pc + ';' +
        'animation-duration:' + (Math.random() * 10 + 10) + 's;' +
        'animation-delay:' + (Math.random() * 6) + 's;' +
        'opacity:0.2;';
      container.appendChild(p);
    }
  });

  // ---- Header scroll effect ----
  var header = document.querySelector('.bts-header');
  if (header) {
    function updateHeader() {
      if (window.scrollY > 100) {
        header.classList.add('bts-header--scrolled');
      } else {
        header.classList.remove('bts-header--scrolled');
      }
    }
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  // ---- Mobile menu toggle ----
  var mobileToggle = document.getElementById('mobile-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  var hamburgerLines = document.querySelectorAll('.bts-header__hamburger');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      if (isOpen && hamburgerLines.length === 3) {
        hamburgerLines[0].style.transform = 'rotate(45deg) translateY(7px)';
        hamburgerLines[1].style.opacity = '0';
        hamburgerLines[2].style.transform = 'rotate(-45deg) translateY(-7px)';
      } else if (hamburgerLines.length === 3) {
        hamburgerLines[0].style.transform = '';
        hamburgerLines[1].style.opacity = '';
        hamburgerLines[2].style.transform = '';
      }
    });

    var mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        if (hamburgerLines.length === 3) {
          hamburgerLines[0].style.transform = '';
          hamburgerLines[1].style.opacity = '';
          hamburgerLines[2].style.transform = '';
        }
      });
    });
  }

  // ---- Scroll fade animations ----
  var fadeElements = document.querySelectorAll('.fade-up, .fade-in');
  var animatedElements = new Set();

  function checkVisibility() {
    fadeElements.forEach(function(el) {
      if (animatedElements.has(el)) return;
      var rect = el.getBoundingClientRect();
      var isVisible = rect.top < window.innerHeight * 0.88;
      if (isVisible) {
        el.classList.add('visible');
        animatedElements.add(el);
      }
    });
  }

  checkVisibility();
  window.addEventListener('scroll', checkVisibility, { passive: true });

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
